// Brazilian money: "R$ 1.234,56". Intl writes a non-breaking space after "R$"; it becomes a plain one.
const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
const plain = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export function formatMoney(value: number | null | undefined, empty = '—'): string {
  return value === null || value === undefined ? empty : currency.format(value).replace(/ /g, ' ')
}

// Text of the money input ("1.234,56", '' when empty).
export function formatMoneyInput(value: number | null | undefined): string {
  return value === null || value === undefined ? '' : plain.format(Math.abs(value))
}

// Digits typed fill from the cents: "1.234,5" + "6" → 1234.56. No digits = null.
export function parseMoneyInput(text: string, negative = false): number | null {
  const digits = text.replace(/\D/g, '').replace(/^0+(?=\d)/, '')
  if (!digits) return null
  const value = Number(digits) / 100
  return negative ? -value : value
}
